import { BASE_IMAGE_ALT } from '@packages/shared/core/common/constants';
import type { PrepareImageDescriptionResult } from '@packages/shared/core/common/entities';

export const isWebp = (url: string) => !!url.match(/\.webp$/);

export const isJpg = (url: string) => !!url.match(/\.(jpeg|jpg)$/);

export const isPng = (url: string) => !!url.match(/\.png$/);

export const prepareImageDescription = (alt: string | null): PrepareImageDescriptionResult => {
  if (alt === '') {
    return { alt: '' };
  }

  if (!alt) {
    return { alt: BASE_IMAGE_ALT, title: BASE_IMAGE_ALT };
  }

  return { alt: `${BASE_IMAGE_ALT} - ${alt}`, title: alt };
};
